import vex from 'vex-js';
import vexDialog from 'vex-dialog';
import { EVENT_BUS } from '@/model/event-bus';
import { getCurrentSceneName } from '@/scenes';
import game from "@/model/game";
import PianoUtil from '@/util/piano-util';
import { store } from '@/model/store';
import { activateScene } from '@/scenes';

vex.registerPlugin(vexDialog);
vex.defaultOptions.className = 'vex-theme-os'

export function prompt(title, message, value) {
    return new Promise((resolve, reject)=>{
        vex.dialog.prompt({
            message,
            value,
            callback: function (value) {
                if (value === false || value === "") {
                    reject();
                } else {
                    resolve(value)
                }
            }
        })
    })
}

export function closePausePopup() {
    vex.closeAll();
}

export function showPausePopup() {
    vex.dialog.open({
        message: 'Game is paused',
        className: 'vex-theme-os vex-pause',
        buttons: [
             {
                ...vex.dialog.buttons.YES,
                type: 'button', // the DOM `type` attribute
                text: 'RESUME', // the textContent of the button
                click: function(event) {
                    EVENT_BUS.emit('MENU_ENTER', getCurrentSceneName());
                    this.close();
                } 
            },
            {
                ...vex.dialog.buttons.YES,
                type: 'button', // the DOM `type` attribute
                text: 'RESTART', // the textContent of the button
                click: function($vexContent, event) {
                    EVENT_BUS.emit('MENU_CLICK', {
                        actionName: 'RESTART'
                    });
                    this.close();
                }
            },
            {
                ...vex.dialog.buttons.YES,
                type: 'button', // the DOM `type` attribute
                text: 'BACK TO MENU', // the textContent of the button
                click: function($vexContent, event) {
                    EVENT_BUS.emit('MENU_CLICK', {
                        actionName: 'REFRESH'
                    });
                    this.close();
                }
            }
        ]
    })
}

function toHex(num) {
    let hex = num.toString(16);
    while (hex.length < 6) {
        hex = '0' + hex;
    }
    return hex;
}

export function showSettingsDialog() {
    vex.dialog.open({
        message: '',
        input: [
            '<style>',
            '.vex-custom-field-wrapper {',
            'margin: 1em 0;',
            '}',
            '.vex-custom-field-wrapper > label {',
            'display: inline-block;',
            'margin-bottom: .2em;',
            '}',
            '</style>',
            // MIDI Device
            '<div class="vex-custom-field-wrapper">',
                '<label class="vex-custom-input-wrapper">Midi Device',
                    '<p>' + game.settings.pianoConfig.title + '</p>',
                    '<sub>' + 
                        PianoUtil.note(game.settings.pianoConfig.boundaries.min).toUpperCase() + 
                        `(${game.settings.pianoConfig.boundaries.min}) - ` +  
                        PianoUtil.note(game.settings.pianoConfig.boundaries.max).toUpperCase() + 
                        `(${game.settings.pianoConfig.boundaries.max}) ${game.settings.pianoConfig.boundaries.max - game.settings.pianoConfig.boundaries.min} keys` +
                        '</sub>',
                        '<button class="vex-dialog-button-primary vex-dialog-button">calibrate</button>',
                '</label>',
            '</div>',
            // music level
            '<div class="vex-custom-field-wrapper">',
            '<label class="vex-custom-input-wrapper" for="musicVolume">Music Volume',
                '<input type="range" max="1" min="0" step="0.1" name="musicVolume" value="'+ game.settings.musicVolume+'"/>',
                '</label>',
            '</div>',

            // piano level
            '<div class="vex-custom-field-wrapper">',
            '<label class="vex-custom-input-wrapper" for="pianoVolume">Piano Volume',
                '<input type="range" max="0" min="-80" step="2" name="pianoVolume" value="'+ game.settings.pianoVolume+'"/>',
                '</label>',
            '</div>',

            // metronome level
            '<div class="vex-custom-field-wrapper">',
            '<label class="vex-custom-input-wrapper" for="metronomeVolume">Metronome Volume',
                '<input type="range" max="0" min="-80" step="2" name="metronomeVolume" value="'+ game.settings.metronomeVolume+'"/>',
                '</label>',
            '</div>',
            
            // no-fail
            '<div class="vex-custom-field-wrapper">',
                '<label  class="vex-custom-input-wrapper" for="date">God Mode (no-fail)',
                    '<input style="margin-left: 100px;" name="godMode" type="checkbox" value="' + game.settings.godMode + '" />',
                '</label>',
            '</div>',
            // offset
            '<div class="vex-custom-field-wrapper">',
                '<label for="offset">Offset</label>',
                '<div class="vex-custom-input-wrapper">',
                    '<input name="offset" type="number" value="' + Number(game.settings.offset || 0) + '" />',
                '</div>',
            '</div>',
            // blackGemColor
            '<div class="vex-custom-field-wrapper">',
                '<label for="blackGemColor">blackGemColor</label>',
                '<div class="vex-custom-input-wrapper">',
                    '<input name="blackGemColor" type="color" value="#'+ toHex(game.settings.blackGemColor) +'" />',
                '</div>',
            '</div>',
            // whiteGemColor
            '<div class="vex-custom-field-wrapper">',
                '<label for="whiteGemColor">whiteGemColor</label>',
                '<div class="vex-custom-input-wrapper">',
                    '<input name="whiteGemColor" type="color" value="#'+ toHex(game.settings.whiteGemColor) +'" />',
                '</div>',
            '</div>',
            // sustainTailColor
            '<div class="vex-custom-field-wrapper">',
                '<label for="sustainTailColor">sustainTailColor</label>',
                '<div class="vex-custom-input-wrapper">',
                    '<input name="sustainTailColor" type="color" value="#'+ toHex(game.settings.sustainTailColor) +'" />',
                '</div>',
            '</div>',
            // lineMaterialColor1
            '<div class="vex-custom-field-wrapper">',
                '<label for="lineMaterialColor1">lineMaterialColor1</label>',
                '<div class="vex-custom-input-wrapper">',
                    '<input name="lineMaterialColor1" type="color" value="#'+ toHex(game.settings.lineMaterialColor1) +'" />',
                '</div>',
            '</div>',
            // lineMaterialColor2
            '<div class="vex-custom-field-wrapper">',
                '<label for="lineMaterialColor2">lineMaterialColor2</label>',
                '<div class="vex-custom-input-wrapper">',
                    '<input name="lineMaterialColor2" type="color" value="#'+ toHex(game.settings.lineMaterialColor2) +'" />',
                '</div>',
            '</div>',
            // rayMaterialColor
            '<div class="vex-custom-field-wrapper">',
                '<label for="rayMaterialColor">rayMaterialColor</label>',
                '<div class="vex-custom-input-wrapper">',
                    '<input name="rayMaterialColor" type="color" value="#'+ toHex(game.settings.rayMaterialColor) +'" />',
                '</div>',
            '</div>',
        ].join(''),
        callback: function (data) {
            if (!data) {
                EVENT_BUS.emit('MENU_CLICK', {
                    actionName: 'REFRESH'
                });
                return console.log('Cancelled')
            } else {
                // save settings
                if (!Object.keys(data).includes('godMode')) {
                    data.godMode = false;
                }
                Object.keys(data).forEach(key => {
                    if (key.includes('Color')) {
                        data[key] = parseInt(data[key].replace('#',''), 16)
                    }

                    if (key == 'offset') {
                        data[key] = parseFloat(data[key])
                    }
                })
                store.updateSettings(data);
                EVENT_BUS.emit('MENU_CLICK', {
                    actionName: 'REFRESH'
                });
            }
            
        }
    })
}